export default __webpack_public_path__ + "static/media/bt1.972efdc8.jpg";